import { BlockContent } from '~/components/BlockContent'

import bootcampStyle from '~/shared/styles/BootcampSanityBlock.module.css'
import { MultipleChoiceOptionsLayout } from '~/types/bootcamp'

export interface MultipleChoiceOptionProps {
  option: unknown[] // Block content
  revealAnswer: boolean
  isRight: boolean
  isSelected: boolean
  onClick: (index: number) => void
  index: number
  totalRightAnswer: number
}

function BootcampMultipleChoiceOption({
  option,
  onClick,
  index,
  isSelected,
  isRight,
  revealAnswer,
  totalRightAnswer,
}: MultipleChoiceOptionProps): React.ReactElement {
  function getColorClasses(): string {
    if (revealAnswer && ((isSelected && isRight) || (totalRightAnswer > 1 && !isSelected && !isRight))) {
      return 'bg-green border-green text-white'
    }
    if (revealAnswer && ((isSelected && !isRight) || (totalRightAnswer > 1 && !isSelected && isRight))) {
      return 'bg-red border-red text-white'
    }
    if (isSelected) {
      return 'bg-purple border-purple text-white'
    }
    return 'text-purple border-purple hover:bg-purple-light-deep'
  }

  return (
    <div
      className={`${
        bootcampStyle['mcq-option']
      } cursor-pointer flex items-center justify-center border-2 duration-300 text-center ${getColorClasses()} rounded p-2`}
      onClick={() => onClick(index)}
      role="option"
    >
      <BlockContent
        blocks={option}
        className={`${bootcampStyle['bootcamp-block-content']} h-full`}
        renderContainerOnSingleChild
      />
    </div>
  )
}

export default BootcampMultipleChoiceOption

export function BootcampMultipleChoiceOptionsWrapper({
  children,
  optionsLayout,
}: {
  children: React.ReactElement
  optionsLayout: MultipleChoiceOptionsLayout
}): React.ReactElement {
  const optionGridClassName = (): string => {
    let gridClassNames = 'grid gap-2 '
    switch (optionsLayout) {
      case MultipleChoiceOptionsLayout.oneColumn:
        gridClassNames = `${gridClassNames}grid-cols-1`
        break
      case MultipleChoiceOptionsLayout.oneRow:
        gridClassNames = `${gridClassNames}grid-flow-col`
        break
      default:
        gridClassNames = `${gridClassNames}grid-cols-2`
    }
    return gridClassNames
  }

  return (
    <div className={` ${optionGridClassName()} `} role="listbox">
      {children}
    </div>
  )
}
